const state = {
    snackbar: {
        snackbar: false,
        message: '',
        timeout: 3000,
        color: 'success',
        top: true,
    },
    dialog: {
        isOpen: false,
        message: 'This is message'
    }
};

// getters
const getters = {};

// actions
const actions = {
    /**
     * Action show message on snackbar
     * @param state
     * @param config
     */
    initSnackbar({state}, config) {
        state.snackbar = {
            ...state.snackbar,
            message: config.message,
            color: config.color,
            snackbar: true,
        };
    },
    /**
     * Show dialog notification
     * @param state
     * @param message
     */
    showDialogNotification({state}, message){
        state.dialog = {
            ...state.dialog,
            isOpen: true,
            message: message,
        }
    }
};

// mutations
const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
